import { apiGet, apiPut, buildQueryString } from "../client";

export async function fetchAdminSupportOverview() {
  return apiGet("/admin/support/overview");
}

export async function fetchAdminSupportMessages(filters = {}) {
  return apiGet(`/admin/support/messages${buildQueryString(filters)}`);
}

export async function fetchAdminSupportMessage(id) {
  return apiGet(`/admin/support/messages/${encodeURIComponent(id)}`);
}

export async function updateAdminSupportMessage(id, payload) {
  return apiPut(`/admin/support/messages/${encodeURIComponent(id)}`, payload || {});
}
